import { useState, ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { cn } from '@/utils/cn';

interface ExpandableSectionProps {
  title: string;
  icon?: ReactNode;
  defaultExpanded?: boolean;
  children: ReactNode;
  variant?: 'default' | 'subtle';
  showDuration?: number; // 显示耗时（秒）
}

export function ExpandableSection({
  title,
  icon,
  defaultExpanded = false,
  children,
  variant = 'default',
  showDuration,
}: ExpandableSectionProps) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div
      className={cn(
        'rounded-lg border transition-all',
        variant === 'default'
          ? 'border-border/40 bg-card/40'
          : 'border-border/20 bg-card/20'
      )}
    >
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center gap-2 px-4 py-2.5 text-left transition-colors hover:bg-accent/5"
      >
        <span className="text-muted-foreground transition-transform">
          {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        </span>
        {icon && <span className="text-muted-foreground">{icon}</span>}
        <span className="flex-1 text-sm font-medium text-foreground">{title}</span>
        {showDuration !== undefined && (
          <span className="text-xs text-muted-foreground">用时 {showDuration} 秒</span>
        )}
      </button>
      {expanded && (
        <div className="border-t border-border/20 px-4 py-3 text-sm text-muted-foreground animate-slide-down">
          {children}
        </div>
      )}
    </div>
  );
}
